export const silver = '#bebebe';
export const white = '#FFF';
export const codGray = '#1e1e1e';
